// Utils
// Types
import type { GetStaticProps, NextPage } from 'next'
// Components
import Head from 'next/head'
import type { FC } from 'react'

import ProjectHeader from '../../components/molecules/projects/ProjectHeader'
import { Post } from '../../types/hashnode'
// Content
import { getPost } from '../../utils/hashnode'

interface Props {
    contractAddress: string
    article: Post
}

const MiniDegens: FC<Props> = ({ article }) => {
    return (
        <article className="prose mx-auto max-w-2xl dark:prose-invert">
            <ProjectHeader
                title="CodeTutor"
                category="Extenção"
                logo="/images/projects/image.png"
                tags={['TypeScript', 'Groq']}
                url="https://github.com/JairRodrigue/CodeTutor"
            />

            <p>
                O CodeTutor é uma extensão para Visual Studio Code que atua como um
                mentor de programação em tempo real. Diferente de assistentes
                tradicionais que apenas completam código, ele utiliza Inteligência
                Artificial (via Groq/Llama 3) e o método socrático para analisar o
                contexto do seu arquivo, fazer perguntas estratégicas e explicar o
                'porquê' por trás da lógica, promovendo um aprendizado profundo
                diretamente no editor.
            </p>

            <h3>Links</h3>

            <ul>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/CodeTutor"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        GitHub
                    </a>
                </li>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/CodeTutor/releases"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        Releases
                    </a>
                </li>
            </ul>

            <a
                className="not-prose my-4 inline-block"
                href="https://marketplace.visualstudio.com/items?itemName=JairRodrigue.CodeTutor"
                title="View on PyPI"
                target="_blank"
                rel="noreferrer"
            >
                <div className="flex w-[220px] items-center gap-3 rounded-lg border bg-white px-4 py-3 shadow-lg">
                    <img
                        src="https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg"
                        alt="PyPI"
                        className="size-8 object-contain"
                    />

                    <div className="leading-tight">
                        <div className="text-xs font-medium text-gray-500">
                            Disponível em
                        </div>
                        <div
                            className="text-lg font-extrabold tracking-tight text-gray-900"
                            style={{ fontFamily: '"Source Sans Pro", system-ui, sans-serif' }}
                        >
                            PyPI
                        </div>
                    </div>
                </div>
            </a>
        </article>
    )
}

const MiniDegensPage: NextPage<Props> = (props) => (
    <div className="container mx-auto">
        <Head>
            <title>CodeTutor</title>
        </Head>

        <MiniDegens {...props} />
    </div>
)

export default MiniDegensPage

export const getStaticProps: GetStaticProps<Props> = async () => {
    return {
        props: {
            contractAddress: '0x24F6328cdDDdad9475c9a3DC2675b5ef851A7C5E',
            article: await getPost('6968db8b1065d3643b0c86fe'),
        },
    }
}
